import { networkConfigSchema } from "./schema.js";
import { verifyDeploymentManifest } from "./deployment.js";
import { GENERATED_DEPLOYMENTS } from "./deployments/index.js";
const UNDEPLOYED_PROTOCOL = {
    factory: null,
    marketplace: null,
    safe: null,
    treasury: null,
};
function defineNetwork(network) {
    const generated = GENERATED_DEPLOYMENTS.find((manifest) => manifest.chainId === network.chainId);
    if (generated === undefined)
        return Object.freeze(networkConfigSchema.parse(network));
    const deployment = verifyDeploymentManifest(generated);
    return Object.freeze(networkConfigSchema.parse({
        ...network,
        protocol: deployment.protocol,
        deploymentBlock: BigInt(deployment.deploymentBlock),
        pancakeV2: deployment.pancakeV2,
    }));
}
/**
 * The only chain-scoped address/configuration source used by SDK, Web, API,
 * Indexer, deployment scripts, and tests. TapeOut addresses remain null until
 * a checksum-verified deployment manifest replaces the complete address set.
 */
export const NETWORKS = Object.freeze({
    31_337: defineNetwork({
        chainId: 31_337,
        name: "Hardhat Local",
        protocol: UNDEPLOYED_PROTOCOL,
        deploymentBlock: null,
        pancakeV2: { factory: null, wbnb: null },
        rpcHttpUrls: ["http://127.0.0.1:8545"],
        publicOrigins: ["http://127.0.0.1:5173"],
        indexerMaxBlockBatch: 50,
        indexerLagSloBlocks: 50,
        indexerCursorAgeSloSeconds: 30,
    }),
    56: defineNetwork({
        chainId: 56,
        name: "BNB Smart Chain",
        protocol: UNDEPLOYED_PROTOCOL,
        deploymentBlock: null,
        pancakeV2: {
            factory: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
            wbnb: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        },
        rpcHttpUrls: ["https://bsc-dataseed.bnbchain.org"],
        publicOrigins: ["https://tapeout-v3.pages.dev"],
        indexerMaxBlockBatch: 50,
        indexerLagSloBlocks: 50,
        indexerCursorAgeSloSeconds: 30,
    }),
    97: defineNetwork({
        chainId: 97,
        name: "BNB Smart Chain Testnet",
        protocol: UNDEPLOYED_PROTOCOL,
        deploymentBlock: null,
        pancakeV2: {
            factory: "0x6725F303b657a9451d8BA641348b6761A6CC7a17",
            wbnb: "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd",
        },
        rpcHttpUrls: ["https://bsc-testnet-dataseed.bnbchain.org"],
        publicOrigins: [],
        indexerMaxBlockBatch: 50,
        indexerLagSloBlocks: 50,
        indexerCursorAgeSloSeconds: 30,
    }),
});
export function getNetworkConfig(chainId) {
    const network = NETWORKS[chainId];
    if (network === undefined) {
        throw new Error(`Unsupported chainId: ${chainId}`);
    }
    return network;
}
export function withNetworkRuntimeOverrides(chainId, overrides) {
    const base = getNetworkConfig(chainId);
    return defineNetwork({ ...base, ...overrides, chainId: base.chainId });
}
//# sourceMappingURL=networks.js.map